import script from "./Assinar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Assinar.vue?vue&type=script&lang=ts&setup=true"

import "./Assinar.vue?vue&type=style&index=0&id=637e602a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637e602a"]])

export default __exports__